"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyboardCommands = keyboardCommands;
exports["default"] = void 0;

var _keypress = _interopRequireDefault(require("keypress.js"));

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function filterInputs(handler) {
  return function (e) {
    return e.target.matches('input, input, select, select *, textarea') || handler(e);
  };
}
/**
 * [keyboardCommands description]
 * @param  {[type]} WrappedComponent component to wrap and add keyboard commands to
 * @param  {[type]} combos           keypress combos array https://dmauro.github.io/Keypress/
 *                                   instead of on_keydown
 *                                   add connectCommand(prop, event, wrappedComponent)
 *                                     this will be called when your combo is pressed
 *                                     in order to control the wrapped component just have
 *                                     this method pass back an object with any props you
 *                                     want overridden on the wrapped component
 *                                   add includeInputs to override input filtering so that
 *                                     a command will run even if the command is run while focused
 *                                     on an input element
 *  EXAMPLES
 *  export default keyboardCommands(WrappedComponent, [{
 *    keys: 'escape',
 *    connectCommand(props) {
 *      props.handlerPassedOnPropsToWrappedComponent();
 *    },
 *  }, {
 *    keys: 'escape',
 *    includeInputs: true, // don't filter out calls that are targeting inputs
 *    connectCommand() {
 *      return { props: 'to', send: 'to', wrapped: 'component'}
 *    },
 *  }]);
 */


function keyboardCommands(WrappedComponent, combos) {
  return /*#__PURE__*/function (_React$PureComponent) {
    _inherits(KeyboardCommands, _React$PureComponent);

    var _super = _createSuper(KeyboardCommands);

    function KeyboardCommands() {
      var _this;

      _classCallCheck(this, KeyboardCommands);

      _this = _super.call(this);
      _this.boundMountComponent = _this.mountComponent.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(KeyboardCommands, [{
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.listener) {
          this.listener.destroy();
        }
      }
    }, {
      key: "getStateWithProps",
      value: function getStateWithProps() {
        // this is used when sending props forward to the wrapped component
        // this enforces that any state that a command has returned is
        // provided to the wrapped component
        return _lodash["default"].assign({}, this.props, this.state);
      }
    }, {
      key: "mountComponent",
      value: function mountComponent(component) {
        var _this2 = this;

        if (this.listener) {
          return;
        }

        this.component = component;

        var handleCommand = function handleCommand(connect, includeInputs) {
          if (!connect) {
            return function () {};
          }

          var handler = function handler(event) {
            // call the connectCommand function offloading the work to the usage code
            var state = connect(_this2.getStateWithProps(), event, _this2.component); // if we have returned a state update the internal state so that it can
            // be pushed down to the wrapped component.

            if (state) {
              _this2.setState(state);

              return state.disablePreventDefault;
            }
          }; // don't execute add an input filter if the combo is set up to
          // include inputs


          return includeInputs ? handler : filterInputs(handler);
        };

        this.listener = new _keypress["default"].Listener();
        this.listener.register_many(combos.map(function (combo) {
          var initialCombo = _lodash["default"].assign(combo, {
            is_solitary: true
          });

          if (combo.connectCommand) {
            initialCombo.on_keydown = handleCommand(combo.connectCommand, combo.includeInputs);
          }

          if (combo.connectReleaseCommand) {
            initialCombo.on_keyup = handleCommand(combo.connectReleaseCommand, combo.includeInputs);
          }

          return initialCombo;
        }));
      }
    }, {
      key: "render",
      value: function render() {
        // use the merged state and props into the wrapped component.
        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, _extends({}, this.getStateWithProps(), {
          ref: this.boundMountComponent
        }));
      }
    }]);

    return KeyboardCommands;
  }(_react["default"].PureComponent);
}

var _default = keyboardCommands;
exports["default"] = _default;